/*
 * Configurateur « Monte ton skate » (Streetart, pack skate -10 %).
 * 6 etapes : board, trucks, roues, roulements, visserie, grip. Le client choisit une piece par
 * etape, puis des accessoires facultatifs (etape 7, collection accessoires-de-skate, prix normal),
 * et ajoute tout au panier ; assets/pack-skate.js applique ensuite les codes.
 * Catalogue : /search?q=tag:<tag>&view=packskate (avec largeur d'axe des trucks), complete par les
 * collections publiques de chaque famille (l'index de recherche peut avoir du retard sur les tags).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pack-builder]');
  if (!root) return;

  var STORAGE_KEY = 'packSkateBuilder';
  var CART_URL = (window.PackSkate && window.PackSkate.root) || '/cart';
  var STEPS = [
    { key: 'board', label: 'Board', tags: ['pack-board'], collections: ['planches-de-skate', 'skateboard'],
      title: '1. Choisis ta board', text: 'La largeur de ta board nous sert à te conseiller des trucks adaptés.' },
    { key: 'trucks', label: 'Trucks', tags: ['pack-trucks'], collections: ['trucks'],
      title: '2. Choisis tes trucks', text: '' },
    { key: 'roues', label: 'Roues', tags: ['pack-roues'], collections: ['roues-skate'],
      title: '3. Choisis tes roues', text: 'Jeu de 4 roues. Petites et dures pour le street, plus grosses et tendres pour le cruising et les sols abîmés.' },
    { key: 'roulements', label: 'Roulements', tags: ['pack-roulements'], collections: ['roulements-skate'],
      title: '4. Choisis tes roulements', text: 'Jeu de 8 roulements, de quoi équiper les 4 roues.' },
    { key: 'visserie', label: 'Visserie', tags: ['pack-visserie'], collections: ['visserie'],
      title: '5. Choisis ta visserie', text: 'Visserie 1 pouce pour un montage sans riser. Prends du 1,5 pouce si tu ajoutes des risers.' },
    { key: 'grip', label: 'Grip', tags: ['pack-grip-offert', 'pack-grip'], collections: ['grip', 'grip-de-skate'],
      title: '6. Choisis ton grip', text: 'Le grip Jessup classique est offert. Les grips à design bénéficient eux aussi de -10 %.' }
  ];

  // Etape 7 (index STEPS.length) : accessoires facultatifs, plusieurs possibles, prix normal (hors remise pack).
  // Etape 8 : recapitulatif. Les deux sont accessibles une fois les 6 pieces choisies.
  var ACC = STEPS.length;
  var ACC_STEP = { key: 'accessoires', label: 'Accessoires', collection: 'accessoires-de-skate' };
  var RECAP = STEPS.length + 1;
  function complete() { return STEPS.every(function (s) { return state.sel[s.key]; }); }

  var catalog = {};
  var state = loadState();
  var els = {
    steps: root.querySelector('[data-pb-steps]'),
    head: root.querySelector('[data-pb-step-head]'),
    grid: root.querySelector('[data-pb-grid]'),
    recap: root.querySelector('[data-pb-recap]'),
    sticky: root.querySelector('[data-pb-sticky]')
  };

  // ---------- utilitaires ----------
  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function loadState() {
    try {
      var s = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (s && s.sel) { s.acc = s.acc || {}; return s; }
    } catch (e) {}
    return { step: 0, sel: {}, acc: {} };
  }
  function saveState() {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }
  function stepIndex(key) {
    for (var i = 0; i < STEPS.length; i++) if (STEPS[i].key === key) return i;
    return -1;
  }
  function isFree(product) {
    return product && product.tags.indexOf('pack-grip-offert') >= 0;
  }
  function parseWidth(text) {
    var m = String(text || '').replace(',', '.').match(/\d+(?:\.\d+)?/g) || [];
    for (var i = 0; i < m.length; i++) {
      var n = parseFloat(m[i]);
      if (n >= 7 && n <= 10.5) return n;
    }
    return null;
  }
  function boardWidth() {
    var b = state.sel.board;
    if (!b) return null;
    return parseWidth(b.variantTitle) || parseWidth(b.title);
  }

  // ---------- catalogue ----------
  function fetchSearch(tag, page) {
    var url = '/search?q=' + encodeURIComponent('tag:' + tag) + '&type=product&options[prefix]=none&view=packskate&page=' + page;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }
  function searchAll(tag) {
    return fetchSearch(tag, 1).then(function (first) {
      var pages = [];
      for (var p = 2; p <= (first.pages || 1); p++) pages.push(fetchSearch(tag, p));
      return Promise.all(pages).then(function (rest) {
        return rest.reduce(function (all, d) { return all.concat(d.products || []); }, first.products || []);
      });
    }).catch(function () { return []; });
  }
  function fromCollection(handle) {
    return fetch('/collections/' + handle + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        return (d.products || []).map(function (p) {
          var img = p.images && p.images[0] ? p.images[0].src : '';
          return {
            handle: p.handle, title: p.title, vendor: p.vendor, url: '/products/' + p.handle,
            image: img ? img + (img.indexOf('?') >= 0 ? '&' : '?') + 'width=360' : '',
            tags: p.tags || [],
            variants: (p.variants || []).filter(function (v) { return v.available; }).map(function (v) {
              return { id: v.id, title: v.title, price: Math.round(parseFloat(v.price) * 100), compare: 0, axle: null };
            })
          };
        });
      })
      .catch(function () { return []; });
  }
  function loadFamily(step) {
    if (catalog[step.key]) return Promise.resolve(catalog[step.key]);
    var jobs = step.tags.map(searchAll).concat(step.collections.map(fromCollection));
    return Promise.all(jobs).then(function (lists) {
      var byHandle = {};
      var order = [];
      lists.forEach(function (list, i) {
        var fromSearch = i < step.tags.length;
        list.forEach(function (p) {
          var tagged = step.tags.some(function (t) { return p.tags.indexOf(t) >= 0; });
          if (!tagged || !p.variants.length) return;
          if (!byHandle[p.handle]) { order.push(p.handle); byHandle[p.handle] = p; }
          else if (fromSearch) byHandle[p.handle] = p; // la recherche porte la largeur d'axe
        });
      });
      catalog[step.key] = order.map(function (h) { return byHandle[h]; });
      return catalog[step.key];
    });
  }
  // Accessoires : toute la collection (pas de tag pack), produits disponibles seulement.
  function loadAccessories() {
    if (catalog[ACC_STEP.key]) return Promise.resolve(catalog[ACC_STEP.key]);
    return fromCollection(ACC_STEP.collection).then(function (list) {
      catalog[ACC_STEP.key] = list.filter(function (p) { return p.variants.length; });
      return catalog[ACC_STEP.key];
    });
  }
  function accList() {
    return Object.keys(state.acc).map(function (h) { return state.acc[h]; });
  }

  // ---------- rendu ----------
  function renderSteps() {
    var html = '';
    STEPS.forEach(function (s, i) {
      var sel = state.sel[s.key];
      var reachable = i === 0 || STEPS.slice(0, i).every(function (p) { return state.sel[p.key]; });
      var cls = (i === state.step ? 'is-current ' : '') + (sel ? 'is-done' : '');
      // Vignette de la piece choisie (selection d'avant cette version : image retrouvee dans le catalogue).
      var img = sel && (sel.image || ((catalog[s.key] || []).filter(function (p) { return p.handle === sel.handle; })[0] || {}).image);
      var thumb = img ? '<img src="' + esc(img.replace(/([?&])width=\d+/, '$1width=120')) + '" alt="" width="40" height="40">' : '';
      html += '<li class="' + cls + '"><button type="button" data-pb-goto="' + i + '"' + (reachable ? '' : ' disabled') + '>' +
        '<span class="pack-builder__thumb" aria-hidden="true">' + thumb + '</span>' +
        '<span class="pack-builder__step-text">' + (i + 1) + '. ' + esc(s.label) + '<small>' + (sel ? esc(sel.title) : 'À choisir') + '</small></span></button></li>';
    });
    var done = complete();
    var accs = accList();
    var accThumb = accs[0] && accs[0].image ? '<img src="' + esc(accs[0].image.replace(/([?&])width=\d+/, '$1width=120')) + '" alt="" width="40" height="40">' : '';
    html += '<li class="' + (state.step === ACC ? 'is-current ' : '') + (accs.length ? 'is-done' : '') + '"><button type="button" data-pb-goto="' + ACC + '"' + (done ? '' : ' disabled') + '>' +
      '<span class="pack-builder__thumb" aria-hidden="true">' + accThumb + '</span>' +
      '<span class="pack-builder__step-text">' + (ACC + 1) + '. ' + ACC_STEP.label + '<small>' +
      (accs.length ? accs.length + ' ajouté' + (accs.length > 1 ? 's' : '') : 'Facultatif') + '</small></span></button></li>';
    html += '<li class="pack-builder__step--recap' + (state.step === RECAP ? ' is-current' : '') + '"><button type="button" data-pb-goto="' + RECAP + '"' + (done ? '' : ' disabled') + '>' +
      '<span class="pack-builder__thumb pack-builder__thumb--recap" aria-hidden="true">' + (done ? '&#10003;' : '') + '</span>' +
      '<span class="pack-builder__step-text">' + (RECAP + 1) + '. Récap<small>' + (done ? money(totals().total) : 'À compléter') + '</small></span></button></li>';
    els.steps.innerHTML = html;
  }

  function truckAdvice() {
    var w = boardWidth();
    if (!w) return 'Prends des trucks dont la largeur d\'axe est proche de la largeur de ta board.';
    return 'Ta board fait ' + w + '". Prends des trucks dont l\'axe est proche de ' + w + '" : ils sont marqués « Conseillé ».';
  }

  function cardPrice(product, variant) {
    if (isFree(product)) return '<s>' + money(variant.price) + '</s> <strong>Offert</strong>';
    var pack = Math.round(variant.price * 0.9);
    return '<s>' + money(variant.price) + '</s> <strong>' + money(pack) + '</strong>';
  }

  function renderGrid() {
    var recap = state.step === RECAP;
    els.grid.classList.toggle('is-recap', recap);
    if (els.recap) els.recap.hidden = recap;
    if (recap) { renderRecapStep(); return; }
    if (state.step === ACC) { renderAccStep(); return; }
    var step = STEPS[state.step];
    els.head.innerHTML = '<h2>' + esc(step.title) + '</h2><p>' + esc(step.key === 'trucks' ? truckAdvice() : step.text) + '</p>';
    els.grid.innerHTML = '<p class="pack-builder__loading">Chargement des pièces…</p>';
    loadFamily(step).then(function (products) {
      if (STEPS[state.step] !== step) return;
      var list = products.slice();
      var w = boardWidth();
      if (step.key === 'trucks' && w) {
        list.sort(function (a, b) { return axleGap(a, w) - axleGap(b, w); });
      }
      if (step.key === 'grip') {
        list.sort(function (a, b) { return (isFree(b) ? 1 : 0) - (isFree(a) ? 1 : 0); });
      }
      if (!list.length) {
        els.grid.innerHTML = '<p>Aucune pièce disponible pour le moment dans cette catégorie.</p>';
        return;
      }
      els.grid.innerHTML = list.map(function (p) { return cardHtml(step, p, w); }).join('');
    });
  }

  function axleOf(product, variant) {
    var v = variant || product.variants[0];
    return v && typeof v.axle === 'number' ? v.axle : null;
  }
  function axleGap(product, w) {
    var best = Infinity;
    product.variants.forEach(function (v) {
      if (typeof v.axle === 'number') best = Math.min(best, Math.abs(v.axle - w));
    });
    return best;
  }

  function cardHtml(step, p, w) {
    var sel = state.sel[step.key];
    var selected = sel && sel.handle === p.handle;
    var current = selected ? p.variants.filter(function (v) { return v.id === sel.variantId; })[0] : null;
    var v = current || p.variants[0];
    var badge = '';
    if (isFree(p)) badge = '<span class="pb-badge">Offert</span>';
    else if (step.key === 'trucks' && w && axleGap(p, w) <= 0.25) badge = '<span class="pb-badge">Conseillé</span>';
    var axle = step.key === 'trucks' && axleOf(p, v) ? '<div>Axe : ' + axleOf(p, v) + '"</div>' : '';
    var select = '';
    if (p.variants.length > 1 || (p.variants[0] && !/^(default title|taille unique)$/i.test(p.variants[0].title))) {
      select = '<select data-pb-variant aria-label="Taille">' + p.variants.map(function (x) {
        var ax = typeof x.axle === 'number' ? ' (axe ' + x.axle + '")' : '';
        return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + '>' + esc(x.title + ax) + '</option>';
      }).join('') + '</select>';
    }
    return '<div class="pb-card' + (selected ? ' is-selected' : '') + '" data-pb-product="' + esc(p.handle) + '">' + badge +
      (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="360" height="360" tabindex="0" role="button" aria-label="Agrandir l\'image : ' + esc(p.title) + '">' : '') +
      '<div class="pb-card__vendor">' + esc(p.vendor) + '</div>' +
      '<div class="pb-card__title"><a href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(p.title) + '</a></div>' +
      axle + select +
      '<div class="pb-card__price" data-pb-price>' + cardPrice(p, v) + '</div>' +
      '<button type="button" class="btn' + (selected ? '' : ' btn--secondary') + '" data-pb-choose>' + (selected ? 'Choisi' : 'Choisir') + '</button>' +
      '</div>';
  }

  // Etape 7 : accessoires au prix normal, ajout / retrait de chaque produit (1 exemplaire).
  function renderAccStep() {
    var n = accList().length;
    els.head.innerHTML = '<h2>' + (ACC + 1) + '. Complète ton setup</h2><p>Facultatif : tool, entretien des roulements, nettoyage du grip. Prix normal, hors remise pack.</p>';
    els.grid.innerHTML = '<p class="pack-builder__loading">Chargement des accessoires…</p>';
    loadAccessories().then(function (products) {
      if (state.step !== ACC) return;
      var cards = products.map(accCardHtml).join('');
      els.grid.innerHTML = (cards || '<p>Aucun accessoire disponible pour le moment.</p>') +
        '<div class="pb-acc__next"><button type="button" class="btn' + (n ? ' btn--secondary' : '') + '" data-pb-goto="' + RECAP + '">' +
        (n ? 'Continuer vers le récap' : 'Passer cette étape') + '</button></div>';
    });
  }

  function accCardHtml(p) {
    var sel = state.acc[p.handle];
    var v = (sel && p.variants.filter(function (x) { return x.id === sel.variantId; })[0]) || p.variants[0];
    var select = '';
    if (p.variants.length > 1 || !/^(default title|taille unique)$/i.test(v.title)) {
      select = '<select data-pb-variant aria-label="Option"' + (sel ? ' disabled' : '') + '>' + p.variants.map(function (x) {
        return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + '>' + esc(x.title) + '</option>';
      }).join('') + '</select>';
    }
    return '<div class="pb-card' + (sel ? ' is-selected' : '') + '" data-pb-product="' + esc(p.handle) + '">' +
      (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="360" height="360" tabindex="0" role="button" aria-label="Agrandir l\'image : ' + esc(p.title) + '">' : '') +
      '<div class="pb-card__vendor">' + esc(p.vendor) + '</div>' +
      '<div class="pb-card__title"><a href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(p.title) + '</a></div>' +
      select +
      '<div class="pb-card__price" data-pb-price><strong>' + money(v.price) + '</strong></div>' +
      '<button type="button" class="btn' + (sel ? '' : ' btn--secondary') + '" data-pb-acc-toggle>' + (sel ? 'Ajouté ✓ (retirer)' : 'Ajouter') + '</button>' +
      '</div>';
  }

  function toggleAcc(card) {
    var handle = card.getAttribute('data-pb-product');
    if (state.acc[handle]) {
      delete state.acc[handle];
    } else {
      var product = (catalog[ACC_STEP.key] || []).filter(function (p) { return p.handle === handle; })[0];
      if (!product) return;
      var select = card.querySelector('[data-pb-variant]');
      var vid = select ? parseInt(select.value, 10) : product.variants[0].id;
      var variant = product.variants.filter(function (v) { return v.id === vid; })[0] || product.variants[0];
      state.acc[handle] = { handle: handle, title: product.title, image: product.image, variantId: variant.id, variantTitle: variant.title, price: variant.price };
    }
    render();
  }

  // pack : prix des 6 pieces remisees ; total : pack + accessoires (prix normal).
  function totals() {
    var full = 0, pack = 0, acc = 0;
    STEPS.forEach(function (s) {
      var sel = state.sel[s.key];
      if (!sel) return;
      full += sel.price;
      pack += sel.free ? 0 : Math.round(sel.price * 0.9);
    });
    accList().forEach(function (a) { acc += a.price; });
    return { full: full + acc, pack: pack, saving: full - pack, acc: acc, total: pack + acc }; // full : prix barre, accessoires compris
  }

  // Etape 8 : toutes les pieces choisies, avec visuel, prix pack et retour a l'etape pour modifier.
  function renderRecapStep(error) {
    var t = totals();
    els.head.innerHTML = '<h2>' + (RECAP + 1) + '. Ton pack</h2><p>Vérifie tes pièces avant de les ajouter au panier.</p>';
    var lines = STEPS.map(function (s, i) {
      var sel = state.sel[s.key];
      if (!sel) return '';
      var img = sel.image || ((catalog[s.key] || []).filter(function (p) { return p.handle === sel.handle; })[0] || {}).image;
      var price = sel.free ? '<s>' + money(sel.price) + '</s> <strong>Offert</strong>' : '<s>' + money(sel.price) + '</s> <strong>' + money(Math.round(sel.price * 0.9)) + '</strong>';
      return '<div class="pb-sum__line">' +
        '<span class="pb-sum__img">' + (img ? '<img src="' + esc(img.replace(/([?&])width=\d+/, '$1width=200')) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</span>' +
        '<span class="pb-sum__info"><span class="pb-sum__family">' + esc(s.label) + '</span><span class="pb-sum__title">' + esc(sel.title) + '</span>' +
        (sel.variantTitle && !/^(default title|taille unique)$/i.test(sel.variantTitle) ? '<span class="pb-sum__variant">' + esc(sel.variantTitle) + '</span>' : '') +
        '<button type="button" class="pb-sum__edit" data-pb-goto="' + i + '">Modifier</button></span>' +
        '<span class="pb-sum__price">' + price + '</span></div>';
    }).join('') + accList().map(function (a) {
      return '<div class="pb-sum__line">' +
        '<span class="pb-sum__img">' + (a.image ? '<img src="' + esc(a.image.replace(/([?&])width=\d+/, '$1width=200')) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</span>' +
        '<span class="pb-sum__info"><span class="pb-sum__family">Accessoire</span><span class="pb-sum__title">' + esc(a.title) + '</span>' +
        (a.variantTitle && !/^(default title|taille unique)$/i.test(a.variantTitle) ? '<span class="pb-sum__variant">' + esc(a.variantTitle) + '</span>' : '') +
        '<button type="button" class="pb-sum__edit" data-pb-goto="' + ACC + '">Modifier</button></span>' +
        '<span class="pb-sum__price"><strong>' + money(a.price) + '</strong></span></div>';
    }).join('');
    els.grid.innerHTML = '<div class="pb-sum">' + lines +
      '<div class="pb-sum__total"><span>' + (t.acc ? 'Total pack + accessoires' : 'Total pack') + '</span><span>' + money(t.total) + '</span></div>' +
      (t.saving > 0 ? '<p class="pb-sum__saving">au lieu de <s>' + money(t.full) + '</s>, soit ' + money(t.saving) + ' d\'économie</p>' : '') +
      '<label class="pb-sum__mount"><input type="checkbox" data-pb-mount' + (state.mount ? ' checked' : '') + '>' +
        '<span><strong>Je veux que mon skate soit monté</strong> (service gratuit)<em>Board grippée et pièces montées par l\'équipe du shop.</em></span></label>' +
      '<button type="button" class="btn btn--full" data-pb-add>Ajouter mon pack au panier</button>' +
      '<button type="button" class="btn btn--full btn--secondary pb-sum__checkout" data-pb-add data-pb-checkout>Passer à l\'achat</button>' +
      (error ? '<p class="pb-recap__error">' + esc(error) + '</p>' : '') +
      '<p class="pb-recap__note" data-pb-note>' + noteText() + '</p></div>';
  }

  // Note du recap : montage demande => skate livre monte (retour d'une piece grippee impossible a l'etat neuf).
  function noteText() {
    return (state.mount
      ? 'Skate livré monté et grippé par le shop. Une fois monté, les pièces ne peuvent plus être retournées à l\'état neuf.'
      : 'Pièces livrées en pack détaché, board non grippée.') + ' Montants indicatifs : la remise exacte est calculée au panier.';
  }

  function renderRecap(error) {
    var count = STEPS.filter(function (s) { return state.sel[s.key]; }).length;
    var t = totals();
    var lines = STEPS.map(function (s, i) {
      var sel = state.sel[s.key];
      if (!sel) return '<div class="pb-recap__line"><span>' + esc(s.label) + '<em>À choisir</em></span><span>–</span></div>';
      var price = sel.free ? '<strong>Offert</strong>' : money(Math.round(sel.price * 0.9));
      return '<div class="pb-recap__line"><span>' + esc(s.label) + '<em>' + esc(sel.title) +
        (sel.variantTitle && !/^(default title|taille unique)$/i.test(sel.variantTitle) ? ' · ' + esc(sel.variantTitle) : '') +
        '</em><button type="button" data-pb-goto="' + i + '">Modifier</button></span><span>' + price + '</span></div>';
    }).join('') + accList().map(function (a) {
      return '<div class="pb-recap__line"><span>Accessoire<em>' + esc(a.title) +
        '</em><button type="button" data-pb-goto="' + ACC + '">Modifier</button></span><span>' + money(a.price) + '</span></div>';
    }).join('');
    els.recap.innerHTML = '<h2>Ton pack</h2>' + lines +
      '<div class="pb-recap__total"><span>' + (t.acc ? 'Total pack + accessoires' : 'Total pack') + '</span><span>' + money(t.total) + '</span></div>' +
      (t.saving > 0 ? '<p class="pb-recap__saving">au lieu de <s>' + money(t.full) + '</s>, soit ' + money(t.saving) + ' d\'économie</p>' : '<p class="pb-recap__saving"></p>') +
      '<button type="button" class="btn btn--full" data-pb-add' + (count < STEPS.length ? ' disabled' : '') + '>' +
      (count < STEPS.length ? 'Encore ' + (STEPS.length - count) + ' pièce' + (STEPS.length - count > 1 ? 's' : '') + ' à choisir' : 'Ajouter mon pack au panier') + '</button>' +
      (error ? '<p class="pb-recap__error">' + esc(error) + '</p>' : '') +
      '<p class="pb-recap__note">Pièces livrées en pack détaché, board non grippée. Montants indicatifs : la remise exacte est calculée au panier.</p>';
    renderSticky(count === STEPS.length, t);
  }

  // Barre fixe mobile (CSS) des que le pack est complet ; decale la bulle du chat Shopify au-dessus.
  function renderSticky(complete, t) {
    if (!els.sticky) return;
    els.sticky.hidden = !complete;
    var page = root.closest('.pack-builder-page');
    if (page) page.classList.toggle('has-sticky', complete);
    if (complete) {
      els.sticky.innerHTML = '<div class="pb-sticky__total">' + (t.acc ? 'Total' : 'Total pack') + '<strong>' + money(t.total) + '</strong></div>' +
        '<button type="button" class="btn" data-pb-add>Ajouter mon pack au panier</button>';
    }
    var h = complete ? els.sticky.offsetHeight : 0;
    if (h) document.documentElement.style.setProperty('--shopify-chat-activator-offset', (h + 12) + 'px');
    else document.documentElement.style.removeProperty('--shopify-chat-activator-offset');
  }

  function render() {
    renderSteps();
    renderGrid();
    renderRecap();
    saveState();
  }

  // ---------- actions ----------
  function choose(card) {
    var step = STEPS[state.step];
    var handle = card.getAttribute('data-pb-product');
    var product = (catalog[step.key] || []).filter(function (p) { return p.handle === handle; })[0];
    if (!product) return;
    var select = card.querySelector('[data-pb-variant]');
    var vid = select ? parseInt(select.value, 10) : product.variants[0].id;
    var variant = product.variants.filter(function (v) { return v.id === vid; })[0] || product.variants[0];
    state.sel[step.key] = {
      handle: product.handle, title: product.title, image: product.image, variantId: variant.id, variantTitle: variant.title,
      price: variant.price, free: isFree(product)
    };
    // Trouver la prochaine etape non remplie ; pack complet : etape 7 (accessoires) la premiere fois, puis le recap.
    var next = state.accSeen ? RECAP : ACC;
    for (var i = 0; i < STEPS.length; i++) {
      var k = (state.step + 1 + i) % STEPS.length;
      if (!state.sel[STEPS[k].key]) { next = k; break; }
    }
    state.step = next;
    render();
    els.head.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // checkout : apres l'ajout et l'application des codes pack, direction le paiement au lieu du panier.
  function addPack(checkout) {
    var items = STEPS.map(function (s) { return { id: state.sel[s.key].variantId, quantity: 1 }; })
      .concat(accList().map(function (a) { return { id: a.variantId, quantity: 1 }; }));
    // Les deux boutons (recap et barre mobile) passent en attente : pas de double ajout.
    root.querySelectorAll('[data-pb-add]').forEach(function (button) {
      button.disabled = true;
      button.textContent = 'Ajout en cours…';
    });
    fetch(CART_URL + '/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Ajout impossible'); });
      // Montage demande (etape 7) : attribut de commande visible dans l'admin ; vide = attribut retire.
      return fetch(CART_URL + '/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Montage du skate': state.mount ? 'Oui (service gratuit)' : '' } })
      }).then(waitForPackCodes, waitForPackCodes);
    }).then(function () {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      window.location.href = checkout ? '/checkout' : CART_URL;
    }).catch(function (err) {
      var msg = err.message + ' Vérifie la disponibilité de la pièce concernée.';
      renderRecap(msg);
      if (state.step === RECAP) renderRecapStep(msg);
    });
  }

  // Laisse a pack-skate.js le temps d'appliquer les codes avant d'ouvrir le panier.
  function waitForPackCodes() {
    var code = window.PackSkate && window.PackSkate.codePack;
    var tries = 0;
    return new Promise(function (resolve) {
      (function poll() {
        tries++;
        fetch(CART_URL + '.js', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var ok = (c.discount_codes || []).some(function (d) { return d.code.toUpperCase() === String(code).toUpperCase(); });
            if (ok || tries >= 12) resolve(); else setTimeout(poll, 700);
          })
          .catch(function () { resolve(); });
      })();
    });
  }

  // Visuel agrandi au clic, comme le plein ecran des fiches produit.
  var zoom = document.querySelector('[data-pb-zoom]');
  var zoomImg = zoom && zoom.querySelector('[data-pb-zoom-img]');
  var zoomOpener = null;
  function openZoom(img) {
    if (!zoom) return;
    zoomOpener = img;
    zoomImg.src = img.currentSrc.replace(/([?&])width=\d+/, '$1width=1400');
    zoomImg.alt = img.alt;
    zoom.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    zoom.querySelector('[data-pb-zoom-close]').focus();
  }
  function closeZoom() {
    if (!zoom || zoom.hidden) return;
    zoom.hidden = true;
    zoomImg.src = 'data:,';
    document.documentElement.style.overflow = '';
    if (zoomOpener) zoomOpener.focus();
  }
  if (zoom) {
    zoom.addEventListener('click', closeZoom);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
  }

  root.addEventListener('click', function (e) {
    var pic = e.target.closest('.pb-card img');
    if (pic) { openZoom(pic); return; }
    var go = e.target.closest('[data-pb-goto]');
    if (go && !go.disabled) {
      if (state.step === ACC) state.accSeen = true;
      state.step = parseInt(go.getAttribute('data-pb-goto'), 10);
      render();
      return;
    }
    var accToggle = e.target.closest('[data-pb-acc-toggle]');
    if (accToggle) { toggleAcc(accToggle.closest('[data-pb-product]')); return; }
    var choice = e.target.closest('[data-pb-choose]');
    if (choice) { choose(choice.closest('[data-pb-product]')); return; }
    var add = e.target.closest('[data-pb-add]');
    if (add && !add.disabled) addPack(add.hasAttribute('data-pb-checkout'));
  });

  root.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.pb-card img')) { e.preventDefault(); openZoom(e.target); }
  });

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-pb-mount]')) {
      state.mount = e.target.checked; saveState();
      var n = root.querySelector('[data-pb-note]'); if (n) n.textContent = noteText();
      return;
    }
    if (!e.target.matches('[data-pb-variant]')) return;
    var card = e.target.closest('[data-pb-product]');
    var key = state.step === ACC ? ACC_STEP.key : STEPS[state.step].key;
    var product = (catalog[key] || []).filter(function (p) { return p.handle === card.getAttribute('data-pb-product'); })[0];
    var vid = parseInt(e.target.value, 10);
    var variant = product && product.variants.filter(function (v) { return v.id === vid; })[0];
    if (variant) card.querySelector('[data-pb-price]').innerHTML = state.step === ACC ? '<strong>' + money(variant.price) + '</strong>' : cardPrice(product, variant);
  });

  // Reprise d'une selection en cours : on revient a la premiere etape non remplie.
  if (state.step > RECAP || state.step < 0 || (state.step >= ACC && !complete())) state.step = 0;
  for (var i = 0; i < STEPS.length; i++) {
    if (!state.sel[STEPS[i].key]) { state.step = Math.min(state.step, i); break; }
  }
  render();
  // Prechargement des autres etapes, puis vignettes des selections reprises.
  Promise.all(STEPS.map(loadFamily)).then(renderSteps);
})();
